'use strict';

module.exports = require('./stateSource');


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/stateSource/index.js
 ** module id = 47
 ** module chunks = 0
 **/